




















































































import Vue from "vue";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import WriteOffDebtLimitter from "./components/WriteOffDebtLimitter.vue";
import CheckBox from "@/components/CheckBox.vue";
import { defaultPossibleWriteOffDebtPreFilter } from "./models/PossibleWriteOffDebtPreFilter";
import PossibleWriteOffDebt from "./models/PossibleWriteOffDebt";
import api from "@/modules/writeOffDebt/api/WriteOffDebtApi"
import eventBus from "@/services/eventBus";
import {getLimitFromStore, setLimitToStore} from "./store/writeOffDebtStore";
import { t } from "@/plugins/i18n";

interface Data {
  limit: boolean;
  direction: boolean;
  refreshEvent: string;
}

interface Methods {
  selected: any;
  sendToApiAddInvoiceToWriteOffDebtTemp: any;
  sendAllSelectedToApiAddInvoiceToWriteOffDebtTemp: any;
  refresh: any;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: { ApiSearchPage, WriteOffDebtLimitter, CheckBox },
  created() {
    this.limit = this.$route.query.limit == "true";
    this.direction = this.$route.query.direction == "true";
  },

  mounted() {
    this.refresh();
  },

  data() {
    return {
      refreshEvent: "refreshWriteOffDebt",
      limit: false,
      direction: false,
      urlIncome: "writeoffdebt/searchincome",
      urlOutgoing: "writeoffdebt/searchoutgoing",
    };
  },

  methods: {
    refresh() {
      eventBus.$emit(this.refreshEvent);
    },
    selected(e: boolean, item: PossibleWriteOffDebt) {
      item.isSelected = e;
    },
    async sendToApiAddInvoiceToWriteOffDebtTemp(item: PossibleWriteOffDebt) {
      await api.AddInvoicesToWriteOffDebtToTmp([{ invoice: item.invoice, code: item.code }]);
      this.refresh();
      eventBus.$emit("success", t("WriteOffDebt_SikeresenHozzaadvaAKivezetesekhez"));
    },
    async sendAllSelectedToApiAddInvoiceToWriteOffDebtTemp(items: PossibleWriteOffDebt[]) {
      const invs = items.filter(x => x.isSelected).map(item => ({
        invoice: item.invoice,
        code: item.code
      }));
      await api.AddInvoicesToWriteOffDebtToTmp(invs);
      this.refresh();
      eventBus.$emit("success", t("WriteOffDebt_TetelekSikeresenHozzaadvaAKivezetesekhez"));
    }
  },

  computed: {
    apiSearchExtraFilter() {
      const extraFilter = defaultPossibleWriteOffDebtPreFilter;
      extraFilter.limit = this.limit ? extraFilter.limit : undefined;
      return extraFilter;
    },
    title() {
      let title = this.limit ? t("WriteOffDebt_KisOsszeguLeiras") : t("WriteOffDebt_LimitNelkuliLeiras");
      title = title + (this.direction ? t("WriteOffDebt_Kimeno") : t("WriteOffDebt_Bejovo"));

      return title;
    },
    columns() {
      return [
        {
          field: "isSelected",
          field2: "isLocked",
          type: "boolean",
          sortable: false,
          filterable: false,
          cell: "selected",
          checkBox: true
        },
        {
          cell: "commandTemplate",
          width: "45px",
          sortable: false,
          filterable: false,
        },
        {
          field: "code",
          title: t("Prefix"),
          width: "74px",
        },
        {
          field: "outer_Inv_No",
          title: t("KulsoSzamlaSzam"),
          width: "150px",
        },
        {
          field: "partnerName",
          title: t("PartnerNeve"),
          width: "150px",
        },
        {
          title: t("WriteOffDebt_LegkorKonyvDat"),
          field: "min_Acc_Date",
          type: "date",
          width: "130px",
          format: "{0:yyyy.MM.dd}",
        },
        {
          title: t("WriteOffDebt_BruttoSzlaP"),
          field: "curr_Total",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_FizetveSzlaP"),
          field: "curr_Payed",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_SzlaPNem"),
          field: "inv_Currency",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_SzlaStatusz"),
          field: "statusName",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_SzlaDatuma"),
          field: "inv_Date",
          type: ColumnType.Date,
          width: "150px",
        },
        {
          title: t("WriteOffDebt_Storno"),
          field: "isStorno",
          width: "150px",
          cell: "checkbox",
        },
        {
          title: t("WriteOffDebt_StornoSzla"),
          field: "invoice_St",
          width: "150px",
        },
        {
          title: t("Helyesbito"),
          field: "isRectify",
          width: "150px",
          cell: "rectifycheckbox",
        },
        {
          title: t("WriteOffDebt_HelyesbitoSzla"),
          field: "invoice_Rect",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_FizetesiHataridoSzla"),
          field: "pterm",
          type: ColumnType.Date,
          width: "130px",
        },
        {
          title: t("FizetesiMod"),
          field: "paymentMode",
          width: "150px",
        },
        {
          title: t("SzamlaSzam"),
          field: "invoice",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_Brutto"),
          field: "total",
          width: "150px",
        },
        {
          title: t("Fizetve"),
          field: "payed",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_Maradvany"),
          field: "toPay",
          width: "150px",
        },
        {
          title: "P.nem",
          field: "currency",
          width: "150px",
        },
        {
          title: t("WriteOffDebt_ElolegErtesito"),
          field: "isDpaym",
          width: "150px",
          cell: "dpaymcheckbox",
        },
      ];
    },
  },
});
